import React from 'react'
import { CobuStack } from '@cobu/ui'
import { Strings } from '../../constants/Strings'

export default function PublicProfileLoading() {
  return (
    <CobuStack f={1} ai="center" jc="center" p="$4">
      <CobuStack ai="center" gap="$2">
        <CobuStack w={40} h={40} br={20} style={{ border: '3px solid var(--cobuTeal)', borderTopColor: 'transparent', animation: 'spin 1s linear infinite' }} />
        <span style={{ color: 'var(--cobuDarkBlue50)' }}>{Strings.get().publicProfile.loading}</span>
      </CobuStack>
      <style>{`@keyframes spin { from { transform: rotate(0deg);} to { transform: rotate(360deg);} }`}</style>
    </CobuStack>
  )
}


